﻿import * as styleTypes from './styleTypes';

export function parseStyleRules(rules, type) {
    let result = {
        hasPoints: false
    }

    let sldRules = convertRules(rules, type, result);

    result.styleType = styleTypes.STYLE_TYPE_CANVAS;
    result.style = sldRules;
    return result;
}

function convertRules(rules, type, holder) {
    let result = {
        rules: [],
        name: '',
        abstract: ''
    };

    if (rules == null) {
        return result;
    }

    for(let i = 0; i < rules.length; i++) {
        let rule = rules[i];
        result.rules.push(convertRule(rule, type, holder, i));
    }

    return result;
}

function convertRule(rule, type, holder, idx) {
    let result = {};

    result.title = rule.Title;
    result.name = rule.Name;
    result.classificationIdx = idx;

    rule.Items.forEach(item => {
        switch (item.$type) {
            case styleTypes.POINT: {
                if (result.pointsymbolizer == null) {
                    result.pointsymbolizer = [];
                }

                result.pointsymbolizer.push(convertPointItem(item));
                holder.hasPoints = true;
                break;
            } 
            case styleTypes.LINE: {
                if (result.linesymbolizer == null) {
                    result.linesymbolizer = [];
                }

                result.linesymbolizer.push(convertLineItem(item));
                break;
            } 
            case styleTypes.POLYGON: {
                if (result.polygonsymbolizer == null) {
                    result.polygonsymbolizer = [];
                }

                result.polygonsymbolizer.push(convertPolygonItem(item));
                break;
            } 
            case styleTypes.LABEL: {
                if (result.textsymbolizer == null) {
                    result.textsymbolizer = [];
                }

                result.textsymbolizer.push(convertLabelItem(item));
                break;
            } 
        }
    });

    parseFilter(result, rule, type);

    if(rule.MaxScaleDenominator != null){
        result.maxscaledenominator = rule.MaxScaleDenominator;
    }

    if(rule.MinScaleDenominator != null){
        result.minscaledenominator = rule.MinScaleDenominator;
    }

    return result;
}

function parseFilter(sldRule, rule, type) {
    let clone = JSON.parse(JSON.stringify(rule));

    if (clone.Item == null) {
        clone.Item = {
            '=': ['xstate', type]
        }
    } else {
        let stateFilter = {
            AND: [{
                '=': ['xstate', type]
            }, clone.Item]
        }
        clone.Item = stateFilter;
    }

    sldRule.filter = convertFilter(clone.Item);
}

function convertFilter(filter) {
    if (filter.AND != null) {
        return convertAndFilter(filter);
    } else if (filter.OR != null) {
        return convertOrFilter(filter);
    } else {
        return convertFilterComparison(filter);
    }
}

function convertAndFilter(filter){
    let result = {
        type: 'and',
        predicates: [convertFilter(filter.AND[0]), convertFilter(filter.AND[1])]
    };

    return result;
}

function convertOrFilter(filter) {
    let result = {
        type: 'or',
        predicates: [convertFilter(filter.OR[0]), convertFilter(filter.OR[1])]
    };

    return result;
}

function convertFilterComparison(filter) {
    let result = {
        type: 'comparison',
        matchcase: true
    };

    let operator = '';

    if (filter[styleTypes.FILTER_COMPARISON_GREATER_THAN]) {
        operator = styleTypes.FILTER_COMPARISON_GREATER_THAN;
        result.operator = styleTypes.FILTER_COMPARISON_GREATER_THAN_OPERATOR;
    }

    if (filter[styleTypes.FILTER_COMPARISON_GREATER_THAN_OR_EQUAL]) {
        operator = styleTypes.FILTER_COMPARISON_GREATER_THAN_OR_EQUAL;
        result.operator = styleTypes.FILTER_COMPARISON_GREATER_THAN_OR_EQUAL_OPERATOR;
    }

    if (filter[styleTypes.FILTER_COMPARISON_LOWER_THAN]) {
        operator = styleTypes.FILTER_COMPARISON_LOWER_THAN;
        result.operator = styleTypes.FILTER_COMPARISON_LOWER_THAN_OPERATOR;
    }

    if (filter[styleTypes.FILTER_COMPARISON_LOWER_THAN_OR_EQUAL]) {
        operator = styleTypes.FILTER_COMPARISON_LOWER_THAN_OR_EQUAL;
        result.operator = styleTypes.FILTER_COMPARISON_LOWER_THAN_OR_EQUAL_OPERATOR;
    }

    if (filter[styleTypes.FILTER_COMPARISON_EQUAL]) {
        operator = styleTypes.FILTER_COMPARISON_EQUAL;
        result.operator = styleTypes.FILTER_COMPARISON_EQUAL_OPERATOR;
    }

    if (filter[styleTypes.FILTER_COMPARISON_NOT_EQUAL]) {
        operator = styleTypes.FILTER_COMPARISON_NOT_EQUAL;
        result.operator = styleTypes.FILTER_COMPARISON_NOT_EQUAL_OPERATOR;
    }

    if (filter[styleTypes.FILTER_COMPARISON_BETWEEN]) {
        operator = styleTypes.FILTER_COMPARISON_BETWEEN;
        result.operator = styleTypes.FILTER_COMPARISON_BETWEEN_OPERATOR;
    }

    if (filter[styleTypes.FILTER_COMPARISON_LIKE]) {
        operator = styleTypes.FILTER_COMPARISON_LIKE;
        result.operator = styleTypes.FILTER_COMPARISON_LIKE_OPERATOR;
    }

    if (filter[styleTypes.FILTER_COMPARISON_IS]) {
        operator = styleTypes.FILTER_COMPARISON_IS;
    }

    let tuples = filter[operator];

    if (filter[styleTypes.FILTER_COMPARISON_IS]) {        
        if (tuples[1] == 'NULL') {
            result.operator = styleTypes.FILTER_COMPARISON_IS_NULL_OPERATOR;
        } else {
            result.operator = styleTypes.FILTER_COMPARISON_IS_NOT_NULL_OPERATOR;
        }
    }

    result.propertyname = tuples[0];

    if (operator == styleTypes.FILTER_COMPARISON_LIKE) {
        result.wildcard = '%';
        result.singlechar = '';
        result.escapechar = null;
    }

    if (operator == styleTypes.FILTER_COMPARISON_BETWEEN) {
        result.lowerboundary = stripSurroundingQuotes(tuples[1]);
        result.upperboundary = stripSurroundingQuotes(tuples[2]);
    } else if (operator != styleTypes.FILTER_COMPARISON_IS) {
        result.literal = stripSurroundingQuotes(tuples[1]);
    }

    return result;
}

// scoate doar ghilimelele simple care inconjoara literalul (stil SLD), pastrand apostrofurile interioare (ex. O'Brien)
function stripSurroundingQuotes(value) {
    if (typeof value != 'string') {
        return value;
    }

    if (value.length >= 2 && value.charAt(0) == "'" && value.charAt(value.length - 1) == "'") {
        return value.substring(1, value.length - 1);
    }

    return value;
}

function convertPointItem(item) {
    let result = {};

    if (item.Graphic != null) {
        result.graphic = {};
        let graphic = item.Graphic;

        if (graphic.Size != null) {
            if (graphic.Size.prop != null) {
                result.graphic.size = {
                    type: 'propertyname',
                    value: graphic.Size.prop
                };
            } else {
                result.graphic.size = graphic.Size.toString();
            }
        }

        if (graphic.Rotation != null) {
            if (graphic.Rotation.prop != null) {
                result.graphic.rotation = {
                    type: 'propertyname',
                    value: graphic.Rotation.prop
                };
            } else {
                result.graphic.rotation = graphic.Rotation.toString();
            }
        }

        if (graphic.Opacity != null) {

            if (graphic.Opacity.prop != null) {
                result.graphic.opacity = {
                    type: 'propertyname',
                    value: graphic.Opacity.prop
                };
            } else {
                result.graphic.opacity = graphic.Opacity.toString();
            }
        }

        if (graphic.Displacement != null) {
            result.graphic.displacement = {};
            let displacement = graphic.Displacement;

            if (displacement.DisplacementX != null) {
                if (displacement.DisplacementX.prop != null) {
                    result.graphic.displacement.displacementx = {
                        type: 'propertyname',
                        value: displacement.DisplacementX.prop
                    };
                } else {
                    result.graphic.displacement.displacementx = displacement.DisplacementX.toString();
                }
            }

            if (displacement.DisplacementY != null) {
                if (displacement.DisplacementY.prop != null) {
                    result.graphic.displacement.displacementy = {
                        type: 'propertyname',
                        value: displacement.DisplacementY.prop
                    };
                } else {
                    result.graphic.displacement.displacementy = displacement.DisplacementY.toString();
                }
            }
        }

        if (graphic.AnchorPoint != null) {
            result.graphic.anchorpoint = {};
            let anchorPoint = graphic.AnchorPoint;

            if (anchorPoint.AnchorPointX != null) {
                result.graphic.anchorpoint.anchorpointx = anchorPoint.AnchorPointX;
            }

            if (anchorPoint.AnchorPointY != null) {
                result.graphic.anchorpoint.anchorpointy = anchorPoint.AnchorPointY;
            }
        }

        if (graphic.Mark != null) {
            result.graphic.mark = {};
            let mark = graphic.Mark;

            if (mark.WellKnownName != null) {
                result.graphic.mark.wellknownname = mark.WellKnownName;
            }

            if (mark.Fill != null) {
                result.graphic.mark.fill = mark.Fill;
            }

            if (mark.Stroke != null) {
                result.graphic.mark.stroke = mark.Stroke;
            }
        }

        if (graphic.ExternalGraphic != null) {
            result.graphic.externalgraphic = {};
            let externalGraphic = graphic.ExternalGraphic;

            if (externalGraphic.OnlineResource != null) {
                if (externalGraphic.OnlineResource.prop != null) {
                    result.graphic.externalgraphic.onlineresource = {
                        type: 'propertyname',
                        value: externalGraphic.OnlineResource.prop
                    };
                } else {
                    result.graphic.externalgraphic.onlineresource = externalGraphic.OnlineResource;
                }
            }
        }
    }

    result.uom = item.Uom;

    return result;
}

function convertLineItem(item) {
    let result = {};

    if (item.Stroke != null) {
        if (item.Stroke.styling != null) {
            result.stroke = {
                styling: {}
            };

            let styling = item.Stroke.styling;

            if (styling.stroke != null) {
                result.stroke.styling.stroke = styling.stroke;
            }

            if (styling.strokeDasharray != null) {
                if (styling.strokeDasharray.prop != null) {
                    result.stroke.styling.strokeDasharray = styling.strokeDasharray;
                } else {
                    result.stroke.styling.strokeDasharray = styling.strokeDasharray + '';
                }
            }

            if (styling.strokeDashoffset != null) {
                if (styling.strokeDashoffset.prop != null) {
                    result.stroke.styling.strokeDashoffset = styling.strokeDashoffset;
                } else {
                    result.stroke.styling.strokeDashoffset = styling.strokeDashoffset.toString();
                }
            }

            if (styling.strokeLinecap != null) {
                result.stroke.styling.strokeLinecap = styling.strokeLinecap;
            }

            if (styling.strokeLinejoin != null) {
                result.stroke.styling.strokeLinejoin = styling.strokeLinejoin;
            }

            if (styling.strokeOpacity != null) {
                if (styling.strokeOpacity.prop != null) {
                    result.stroke.styling.strokeOpacity = styling.strokeOpacity;
                } else {
                    result.stroke.styling.strokeOpacity = styling.strokeOpacity.toString();
                }
                
            }

            if (styling.strokeWidth != null) {
                if (styling.strokeWidth.prop != null) {
                    result.stroke.styling.strokeWidth = styling.strokeWidth;
                } else {
                    result.stroke.styling.strokeWidth = styling.strokeWidth.toString();
                }
            }
        } else if (item.Stroke.GraphicStroke != null){
            result.stroke = {
                graphicstroke: {
                    graphic: {},
                    gap: 0
                }
            };

            let resultGraphicStroke = result.stroke.graphicstroke;
            let graphicStroke = item.Stroke.GraphicStroke;

            if (graphicStroke.Gap != null) {
                resultGraphicStroke.gap = graphicStroke.Gap;
            }

            if (graphicStroke.Graphic != null) {
                let graphic = graphicStroke.Graphic;

                if (graphic.Size != null) {

                    if (graphic.Size.prop != null) {
                        resultGraphicStroke.graphic.size = {
                            type: 'propertyname',
                            value: graphic.Size.prop
                        };
                    } else {
                        resultGraphicStroke.graphic.size = graphic.Size.toString();
                    }
                }

                if (graphic.Rotation != null) {
                    if (graphic.Rotation.prop != null) {
                        resultGraphicStroke.graphic.rotation = {
                            type: 'propertyname',
                            value: graphic.Rotation.prop
                        };
                    } else {
                        resultGraphicStroke.graphic.rotation = graphic.Rotation.toString();
                    }
                }

                if (graphic.Opacity != null) {
                    if (graphic.Opacity.prop != null) {
                        resultGraphicStroke.graphic.opacity = {
                            type: 'propertyname',
                            value: graphic.Opacity.prop
                        };
                    } else {
                        resultGraphicStroke.graphic.opacity = graphic.Opacity.toString();
                    }
                }

                if (graphic.Mark != null) {
                    resultGraphicStroke.graphic.mark = {};
                    let mark = graphic.Mark;

                    if (mark.WellKnownName != null) {
                        resultGraphicStroke.graphic.mark.wellknownname = mark.WellKnownName;
                    }

                    if (mark.Fill != null) {
                        resultGraphicStroke.graphic.mark.fill = mark.Fill;
                    }

                    if (mark.Stroke != null) {
                        resultGraphicStroke.graphic.mark.stroke = mark.Stroke;
                    }
                }

                if (graphic.ExternalGraphic != null) {
                    resultGraphicStroke.graphic.externalgraphic = {};
                    let externalGraphic = graphic.ExternalGraphic;

                    if (externalGraphic.OnlineResource != null) {
                        resultGraphicStroke.graphic.externalgraphic.onlineresource = externalGraphic.OnlineResource;
                    }
                }
            }
        }
    }

    result.uom = item.Uom;

    return result;
}

function convertPolygonItem(item) {
    let result = {};

    if (item.Stroke != null) {
        if (item.Stroke.styling != null) {
            result.stroke = {
                styling: {}
            };

            let styling = item.Stroke.styling;

            if (styling.stroke != null) {
                result.stroke.styling.stroke = styling.stroke;
            }

            if (styling.strokeDasharray != null) {
                if (styling.strokeDasharray.prop != null) {
                    result.stroke.styling.strokeDasharray = styling.strokeDasharray;
                } else {
                    result.stroke.styling.strokeDasharray = styling.strokeDasharray + '';
                }
            }

            if (styling.strokeDashoffset != null) {
                if (styling.strokeDashoffset.prop != null) {
                    result.stroke.styling.strokeDashoffset = styling.strokeDashoffset;
                } else {
                    result.stroke.styling.strokeDashoffset = styling.strokeDashoffset.toString();
                }
            }

            if (styling.strokeLinecap != null) {
                result.stroke.styling.strokeLinecap = styling.strokeLinecap;
            }

            if (styling.strokeLinejoin != null) {
                result.stroke.styling.strokeLinejoin = styling.strokeLinejoin;
            }

            if (styling.strokeOpacity != null) {
                if (styling.strokeOpacity.prop != null) {
                    result.stroke.styling.strokeOpacity = styling.strokeOpacity;
                } else {
                    result.stroke.styling.strokeOpacity = styling.strokeOpacity.toString();
                }
            }

            if (styling.strokeWidth != null) {
                if (styling.strokeWidth.prop != null) {
                    result.stroke.styling.strokeWidth = styling.strokeWidth;
                } else {
                    result.stroke.styling.strokeWidth = styling.strokeWidth.toString();
                }
            }
        } else if (item.Stroke.GraphicStroke != null) {
            result.stroke = {
                graphicstroke: {
                    graphic: {},
                    gap: 0
                }
            };

            let resultGraphicStroke = result.stroke.graphicstroke;
            let graphicStroke = item.Stroke.GraphicStroke;

            if (graphicStroke.Gap != null) {
                resultGraphicStroke.gap = graphicStroke.Gap;
            }

            if (graphicStroke.Graphic != null) {
                let graphic = graphicStroke.Graphic;

                if (graphic.Size != null) {
                    if (graphic.Size.prop != null) {
                        resultGraphicStroke.graphic.size = {
                            type: 'propertyname',
                            value: graphic.Size.prop
                        };
                    } else {
                        resultGraphicStroke.graphic.size = graphic.Size.toString();
                    }
                }

                if (graphic.Rotation != null) {
                    if (graphic.Rotation.prop != null) {
                        resultGraphicStroke.graphic.rotation = {
                            type: 'propertyname',
                            value: graphic.Rotation.prop
                        };
                    } else {
                        resultGraphicStroke.graphic.rotation = graphic.Rotation.toString();
                    }
                }

                if (graphic.Opacity != null) {
                    if (graphic.Opacity.prop != null) {
                        resultGraphicStroke.graphic.opacity = {
                            type: 'propertyname',
                            value: graphic.Opacity.prop
                        };
                    } else {
                        resultGraphicStroke.graphic.opacity = graphic.Opacity.toString();
                    }
                }

                if (graphic.Mark != null) {
                    resultGraphicStroke.graphic.mark = {};
                    let mark = graphic.Mark;

                    if (mark.WellKnownName != null) {
                        resultGraphicStroke.graphic.mark.wellknownname = mark.WellKnownName;
                    }

                    if (mark.Fill != null) {
                        resultGraphicStroke.graphic.mark.fill = mark.Fill;
                    }

                    if (mark.Stroke != null) {
                        resultGraphicStroke.graphic.mark.stroke = mark.Stroke;
                    }
                }

                if (graphic.ExternalGraphic != null) {
                    resultGraphicStroke.graphic.externalgraphic = {};
                    let externalGraphic = graphic.ExternalGraphic;

                    if (externalGraphic.OnlineResource != null) {
                        resultGraphicStroke.graphic.externalgraphic.onlineresource = externalGraphic.OnlineResource;
                    }
                }
            }
        }
    }

    if (item.Fill != null) {
        if (item.Fill.styling != null) {
            result.fill = {
                styling: {}
            };

            let styling = item.Fill.styling;

            if (styling.fill != null) {
                result.fill.styling.fill = styling.fill;
            }

            if (styling.fillOpacity != null) {
                result.fill.styling.fillOpacity = styling.fillOpacity;
            }
        } else if (item.Fill.GraphicFill != null) {
            result.fill = {
                graphicfill: {
                    graphic: {}
                }
            };

            let resultGraphicFill = result.fill.graphicfill;
            let graphicFill = item.Fill.GraphicFill;

            if (graphicFill.Gap != null) {
                resultGraphicFill.gap = graphicFill.Gap;
            }

            if (graphicFill.Graphic != null) {
                let graphic = graphicFill.Graphic;

                if (graphic.Size != null) {
                    if (graphic.Size.prop != null) {
                        resultGraphicFill.graphic.size = {
                            type: 'propertyname',
                            value: graphic.Size.prop
                        };
                    } else {
                        resultGraphicFill.graphic.size = graphic.Size.toString();
                    }
                }

                if (graphic.Rotation != null) {
                    if (graphic.Rotation.prop != null) {
                        resultGraphicFill.graphic.rotation = {
                            type: 'propertyname',
                            value: graphic.Rotation.prop
                        };
                    } else {
                        resultGraphicFill.graphic.rotation = graphic.Rotation.toString();
                    }
                }

                if (graphic.Opacity != null) {
                    if (graphic.Opacity.prop != null) {
                        resultGraphicFill.graphic.opacity = {
                            type: 'propertyname',
                            value: graphic.Opacity.prop
                        };
                    } else {
                        resultGraphicFill.graphic.opacity = graphic.Opacity.toString();
                    }
                }

                if (graphic.Mark != null) {
                    resultGraphicFill.graphic.mark = {};
                    let mark = graphic.Mark;

                    if (mark.WellKnownName != null) {
                        resultGraphicFill.graphic.mark.wellknownname = mark.WellKnownName;
                    }

                    if (mark.Fill != null) {
                        resultGraphicFill.graphic.mark.fill = mark.Fill;
                    }

                    if (mark.Stroke != null) {
                        resultGraphicFill.graphic.mark.stroke = mark.Stroke;
                    }
                }

                if (graphic.ExternalGraphic != null) {
                    resultGraphicFill.graphic.externalgraphic = {};
                    let externalGraphic = graphic.ExternalGraphic;

                    if (externalGraphic.OnlineResource != null) {
                        resultGraphicFill.graphic.externalgraphic.onlineresource = externalGraphic.OnlineResource;
                    }
                }
            }
        }
    }

    result.uom = item.Uom;

    return result;
}

function convertLabelItem(item) {
    let result = {};
    if (item.Label != null && item.Label.prop != null) {
        result.label = {
            type: 'expression',
            children: [
                {
                    type: 'literal',
                    value: ''
                },
                {
                    type: 'propertyname',
                    value: item.Label.prop
                },
                {
                    type: 'literal',
                    value: ''
                }
            ]
        }
    } else if (item.Label != null) {
        result.label = {
            type: 'static',
            value: item.Label
        }
    }

    if (item.Font != null) {
        result.font = {
            styling: {
                fontFamily: item.Font.fontFamily,
                fontSize: item.Font.fontSize,
                fontStyle: item.Font.fontStyle,
                fontWeight: item.Font.fontWeight
            }
        }
    }

    if (item.Fill != null && item.Fill.styling != null) {
        result.fill = {
            styling: {
                fill: item.Fill.styling.fill,
                fillOpacity: item.Fill.styling.fillOpacity
            }
        }
    }

    if (item.Halo != null && item.Halo.Fill != null && item.Halo.Radius != null) {
        result.halo = {
            radius: item.Halo.Radius,
            fill: {
                styling: {
                    fill: item.Halo.Fill.styling.fill,
                    fillOpacity: item.Halo.Fill.styling.fillOpacity
                }
            }
        }
    }

    if (item.PointPlacement != null) {
        result.labelplacement = {
            pointplacement: {}
        }

        if (item.PointPlacement.AnchorPoint != null) {
            result.labelplacement.pointplacement.anchorpoint = {
                anchorpointx: item.PointPlacement.AnchorPoint.AnchorPointX,
                anchorpointy: item.PointPlacement.AnchorPoint.AnchorPointY
            }
        }

        if (item.PointPlacement.Rotation != null) {
            result.labelplacement.pointplacement.rotation = item.PointPlacement.Rotation;
        }

        if (item.PointPlacement.Displacement != null) {
            result.labelplacement.pointplacement.displacement = {
                displacementx: item.PointPlacement.Displacement.DisplacementX,
                displacementy: item.PointPlacement.Displacement.DisplacementY
            }
        }
    }

    if (item.LinePlacement != null) {
        result.labelplacement = {
            lineplacement: {}
        }

        if (item.LinePlacement.PerpendicularOffset) {
            result.labelplacement.lineplacement.perpendicularoffset = item.LinePlacement.PerpendicularOffset;
        }
    }

    if (item.options != null) {
        result.vendoroption = {
            partials: true,
            conflictresolution: item.options.conflictResolution
        }

        if (item.options.followLine != null) {
            result.vendoroption.followline = item.options.followLine;
        }

        if (item.options.repeat != null) {
            result.vendoroption.repeat = item.options.repeat;
        }
    }

    result.uom = item.Uom;

    return result;
}